<div class="container-xl mt-4">
  <div class="row" *ngIf="on_bonnie === false">
    <div class="col">
      <ng-container *ngFor="let service of services; let index = index;">
        <div class="row align-items-center border-bottom pb-4 service-item" [hidden]="service.display == 0" [class.mb-4]="index === 0" [class.mt-3]="index === 0" [class.my-4]="index !== 0">
          <div class="col-12 col-md-8">
            <span class="lemon-milk-light">{{ service.name }}</span>
          </div>
          <div *ngIf="service.description" class="col-12">
            <div style="font-size: 14px;" class="my-2">
              {{ service.description }}
              <span (click)="openModal(service, bookNowBtn)" class="text-blue ml-1" *ngIf="service.description !== service.description_full" style="cursor: pointer;"><u>Read More</u></span>
            </div>
          </div>
          <div [class.offset-md-8]="service.description" class="col-8 col-md-2">
            <div class="row">
              <div class="col-5 col-md-12">{{ service.price | currency}}</div>
              <div class="col-7 col-md-12"><small>{{ service.time_taken }}</small></div>
            </div>
          </div>
          <div class="col-4 col-md-2">
            <a #bookNowBtn [routerLink]="'/book-appointment/' + service.id" class="btn btn-outline-dark btn-sm book-button">
              <span (click)="setActiveSalon(salon, $event)">Book Now</span>
            </a>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>